// extracted by mini-css-extract-plugin
export default {"root":"_1ArzqQOx","button":"_3jq98mXF"};